import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Badge from '../../../components/ui/Badge';
import { Card } from '../../../components/ui/Card';

const LeadCard = ({ lead, onAssignOwner, onAddNote, onConvert, onStageChange, isDragging }) => {
  const getScoreVariant = (score) => {
    if (score >= 60) return 'success';
    if (score >= 40) return 'warning';
    return 'danger';
  };

  const getSourceIcon = (source) => {
    const icons = {
      'direct': 'UserCheck',
      'broker': 'Briefcase',
      'website': 'Globe',
      'referral': 'Users',
      'social': 'Share2'
    };
    return icons?.[source] || 'HelpCircle';
  };

  return (
    <Card
      padding="sm"
      shadow="sm"
      hover
      className={`mb-3 cursor-move ${isDragging ? 'opacity-50 shadow-lg' : ''}`}
    >
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h4 className="font-heading font-semibold text-foreground text-body mb-1 truncate">
            {lead?.name}
          </h4>
          <p className="text-body-sm text-muted-foreground truncate">
            {lead?.company}
          </p>
        </div>
        <Badge variant={getScoreVariant(lead?.aiScore)} icon="Zap" size="sm" className="flex-shrink-0 ml-2">
          {lead?.aiScore}
        </Badge>
      </div>
      <div className="space-y-2 mb-3">
        <div className="flex items-center gap-2 text-body-sm">
          <Icon name="Users" size={16} className="text-muted-foreground" />
          <span className="text-foreground font-medium">{lead?.seatsRequired} seats</span>
        </div>
        <div className="flex items-center gap-2 text-body-sm">
          <Icon name="IndianRupee" size={16} className="text-muted-foreground" />
          <span className="text-foreground font-medium">
            ₹{lead?.budgetPerSeat?.toLocaleString('en-IN')}/seat
          </span>
        </div>
        <div className="flex items-center gap-2 text-body-sm">
          <Icon name={getSourceIcon(lead?.source)} size={16} className="text-muted-foreground" />
          <span className="text-muted-foreground capitalize">{lead?.source}</span>
        </div>
      </div>
      {lead?.owner && (
        <div className="flex items-center gap-2 mb-3 p-2 bg-muted rounded-lg">
          <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
            <Icon name="User" size={14} className="text-primary-600" />
          </div>
          <span className="text-caption text-muted-foreground truncate">{lead?.owner}</span>
        </div>
      )}
      <div className="flex flex-col sm:flex-row gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="UserPlus"
          iconPosition="left"
          onClick={() => onAssignOwner(lead)}
          className="flex-1"
        >
          Assign
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="MessageSquare"
          iconPosition="left"
          onClick={() => onAddNote(lead)}
          className="flex-1"
        >
          Note
        </Button>
        {lead?.stage === 'qualified' && (
          <Button
            variant="success"
            size="sm"
            iconName="CheckCircle"
            iconPosition="left"
            onClick={() => onConvert(lead)}
            className="flex-1 sm:flex-none"
          >
            Convert
          </Button>
        )}
      </div>
    </Card>
  );
};

export default LeadCard;